import { TILE_SIZES } from '@mixtiles/web-backend-shared'

export const COLLAGE_FONT_COLOR = '#000000'
export const COLLAGE_FONTS = {
  handwriting: {
    id: 'handwriting',
    title: 'Handwriting',
    url: 'https://fonts.googleapis.com/css2?family=Bad%20Script&display=swap',
    fontFamily: 'Bad Script, cursive',
  },
  bold: {
    id: 'bold',
    title: 'BOLD',
    url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap',
    fontFamily: 'Montserrat, sans-serif',
  },
  classic: {
    id: 'classic',
    title: 'CLASSIC',
    url: 'https://fonts.googleapis.com/css2?family=EB%20Garamond&display=swap',
    fontFamily: 'EB Garamond, serif',
  },
}

export const ORDERED_TEXT_STYLES = [
  COLLAGE_FONTS.handwriting.id,
  COLLAGE_FONTS.classic.id,
  COLLAGE_FONTS.bold.id,
]

export const COLLAGE_TEXT_MAX_LENGTH = 28

export function getFontSize(textLength) {
  return textLength < 18 ? 90 : 60
}

/* eslint-disable no-useless-escape */
const WHITELIST_CHARS_REGEX =
  /[^ ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_~`"';:,><=!@#%&\.\^\$\|\/\?\*\(\)\{\}\-\\+[\]]/g

export function whitelistText(text) {
  return text.replace(WHITELIST_CHARS_REGEX, '')
}

export const TEXT_UNSUPPORTED_SIZES = [
  TILE_SIZES.RECTANGLE_22X44,
  TILE_SIZES.RECTANGLE_44X22,
]
